module.exports = __webpack_public_path__ + "static/media/16.928c9fcc.png";